/*
 * Drawer icon set — same 24px grid and stroke weight as the bottom-nav
 * icons, so the two navigation surfaces read as one system.
 */

const base = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
};

export const DHome = () => (
  <svg {...base}>
    <path d="M3 10.2 12 3l9 7.2" />
    <path d="M5.5 9.2V20h13V9.2" />
    <path d="M9.8 20v-5.2h4.4V20" />
  </svg>
);

export const DShop = () => (
  <svg {...base}>
    <path d="M4 9.5V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.5" />
    <path d="M3 5.5h18l1 4a2.6 2.6 0 0 1-5.1.6 2.6 2.6 0 0 1-4.9.6 2.6 2.6 0 0 1-4.9-.6A2.6 2.6 0 0 1 2 9.5z" />
  </svg>
);

export const DSparkle = () => (
  <svg {...base}>
    <path d="M12 3.2l1.9 4.6 4.9.4-3.7 3.2 1.1 4.8L12 13.7l-4.2 2.5 1.1-4.8-3.7-3.2 4.9-.4z" />
    <path d="M18.5 17.5l.7 1.7 1.8.2-1.4 1.2.4 1.8-1.5-.9-1.5.9.4-1.8-1.4-1.2 1.8-.2z" />
  </svg>
);

export const DHeart = () => (
  <svg {...base}>
    <path d="M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 0 0-7.1 7.1l8.8 8.8 8.8-8.8a5 5 0 0 0 0-7.1z" />
  </svg>
);

export const DCart = () => (
  <svg {...base}>
    <circle cx="9.5" cy="20" r="1.4" />
    <circle cx="18" cy="20" r="1.4" />
    <path d="M2.5 3.5h2.6l2.2 11.1a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.3l1.4-7.2H6" />
  </svg>
);

export const DCompare = () => (
  <svg {...base}>
    <path d="M4 6.5h7M13 17.5h7" />
    <path d="M8 3.2 4 6.5l4 3.3" />
    <path d="M16 14.2l4 3.3-4 3.3" />
  </svg>
);

export const DCard = () => (
  <svg {...base}>
    <rect x="2.6" y="5" width="18.8" height="14" rx="2.4" />
    <path d="M2.6 9.8h18.8" />
  </svg>
);

export const DTruck = () => (
  <svg {...base}>
    <path d="M2.8 6.2h10.4v9.6H2.8z" />
    <path d="M13.2 9.4h3.9l3.1 3v3.4h-7z" />
    <circle cx="7" cy="18" r="1.7" />
    <circle cx="17.2" cy="18" r="1.7" />
  </svg>
);

export const DReturn = () => (
  <svg {...base}>
    <path d="M3.6 9.4a8.4 8.4 0 1 1-.5 5" />
    <path d="M3.2 4.6v4.8H8" />
  </svg>
);

export const DUser = () => (
  <svg {...base}>
    <circle cx="12" cy="8" r="3.8" />
    <path d="M4.6 20.2a7.6 7.6 0 0 1 14.8 0" />
  </svg>
);

export const DInfo = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.2M12 7.9h.01" />
  </svg>
);

export const DMail = () => (
  <svg {...base}>
    <rect x="2.8" y="5" width="18.4" height="14" rx="2.4" />
    <path d="m3.4 6.6 8.6 6 8.6-6" />
  </svg>
);

export const DHandshake = () => (
  <svg {...base}>
    <path d="M2.8 9.2 6.4 6h4.2l1.4 1.3L10.6 9a1.6 1.6 0 0 0 .1 2.4l3.2 2.8" />
    <path d="M13 6.6h4.6l3.6 3.2-3.4 5.6-2.4-1.6" />
    <path d="M4.4 10.6 2.8 15l2.6 2.2 2.4-1.4" />
  </svg>
);

export const DTag = () => (
  <svg {...base}>
    <path d="M3.4 11.6V4.2a.8.8 0 0 1 .8-.8h7.4l8.6 8.6a1.8 1.8 0 0 1 0 2.5l-5.3 5.3a1.8 1.8 0 0 1-2.5 0z" />
    <path d="M7.6 7.6h.01" />
  </svg>
);

export const DBuilding = () => (
  <svg {...base}>
    <path d="M4.6 20.4V4.8a1.4 1.4 0 0 1 1.4-1.4h7a1.4 1.4 0 0 1 1.4 1.4v15.6" />
    <path d="M14.4 9.6h3.6a1.4 1.4 0 0 1 1.4 1.4v9.4" />
    <path d="M3 20.4h18M8 7.4h3M8 11.4h3M8 15.4h3" />
  </svg>
);

export const DBox = () => (
  <svg {...base}>
    <path d="m12 3 8.4 4.4v9.2L12 21l-8.4-4.4V7.4z" />
    <path d="m3.6 7.4 8.4 4.4 8.4-4.4M12 21v-9.2" />
  </svg>
);

export const DShield = () => (
  <svg {...base}>
    <path d="M12 3.2 20 6v6c0 4.4-3.2 7.6-8 9-4.8-1.4-8-4.6-8-9V6z" />
  </svg>
);

export const DDoc = () => (
  <svg {...base}>
    <path d="M13.4 3.2H6.8a1.8 1.8 0 0 0-1.8 1.8v14a1.8 1.8 0 0 0 1.8 1.8h10.4a1.8 1.8 0 0 0 1.8-1.8V8.6z" />
    <path d="M13.4 3.2v5.4h5.6" />
  </svg>
);

export const DClose = () => (
  <svg {...base} strokeWidth="2">
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const DSearch = () => (
  <svg {...base}>
    <circle cx="10.8" cy="10.8" r="6.6" />
    <path d="m15.7 15.7 4 4" />
  </svg>
);

export const DPhone = () => (
  <svg {...base}>
    <path d="M21 16.4v2.6a1.8 1.8 0 0 1-2 1.8 17.6 17.6 0 0 1-15.2-15.2 1.8 1.8 0 0 1 1.8-2h2.6a1.8 1.8 0 0 1 1.8 1.5c.1.9.3 1.8.6 2.6a1.8 1.8 0 0 1-.4 1.9l-1.1 1.1a14.4 14.4 0 0 0 5.4 5.4l1.1-1.1a1.8 1.8 0 0 1 1.9-.4c.8.3 1.7.5 2.6.6a1.8 1.8 0 0 1 1.5 1.8z" />
  </svg>
);

export const DChevron = () => (
  <svg {...base} width="16" height="16" strokeWidth="2">
    <path d="m9 5 7 7-7 7" />
  </svg>
);
